import * as THREE from 'three';
//import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
//import { GUI } from 'three/examples/jsm/libs/dat.gui.module.js';
//import { Stats } from 'three/examples/jsm/libs/stats.module.js';

export function clothEffect(mountRef, textileImage) {
// START THREEJS

    var params = {
      enableWind: true,
    }

    var viewSize = 20;
    var aspectRatio = window.innerWidth / window.innerHeight;
    var originalAspect = window.innerWidth / window.innerHeight;

    var DAMPING = 0.05;
    var DRAG = 1 - DAMPING;
    var MASS = 0.75; //Tweak this to adjust behaviour
    var restDistance = 40;
    var xSegs = 10; //changing X width of cloth, default is 16
    var ySegs = 10; //changing Y width of cloth, default is 12
    var clothFunction = plane( restDistance * xSegs, restDistance * ySegs );
    var cloth = new Cloth( xSegs, ySegs );
    var GRAVITY = 1281 * 1.4; //Tweak this to adjust behaviour
    var gravity = new THREE.Vector3( 0, - GRAVITY, 0 ).multiplyScalar( MASS );
    var TIMESTEP = 18 / 1000;
    var TIMESTEP_SQ = TIMESTEP * TIMESTEP;
    var pins = [];
    var windForce = new THREE.Vector3( 0, 0, 0 );
    var tmpForce = new THREE.Vector3();
    var lastTime;
    
    function plane( width, height ) { 
      return function ( u, v, target ) {
        var x = ( u - 0.5 ) * width;
        var y = ( v + 0.5 ) * height;
        var z = 0;
        target.set( x, y, z );
      };
    }

    function Particle ( x, y, z, mass ) {
      this.position = new THREE.Vector3();
      this.previous = new THREE.Vector3();
      this.original = new THREE.Vector3();
      this.a = new THREE.Vector3( 0, 0, 0 ); // acceleration
      this.mass = mass;
      this.invMass = 1 / mass;
      this.tmp = new THREE.Vector3();
      this.tmp2 = new THREE.Vector3();
      // init
      clothFunction( x, y, this.position ); // position
      clothFunction( x, y, this.previous ); // previous
      clothFunction( x, y, this.original );
    }
    // Force -> Acceleration
    Particle.prototype.addForce = function ( force ) {
      this.a.add(
        this.tmp2.copy( force ).multiplyScalar( this.invMass )
      );
    };
    // Performs Verlet integration
    Particle.prototype.integrate = function ( timesq ) {
      var newPos = this.tmp.subVectors( this.position, this.previous );
      newPos.multiplyScalar( DRAG ).add( this.position );
      newPos.add( this.a.multiplyScalar( timesq ) );
      this.tmp = this.previous;
      this.previous = this.position;
      this.position = newPos;
      this.a.set( 0, 0, 0 );
    };
    var diff = new THREE.Vector3();
    function satisfyConstraints( p1, p2, distance ) {
      diff.subVectors( p2.position, p1.position );
      var currentDist = diff.length();
      if ( currentDist === 0 ) return; // prevents division by 0
      var correction = diff.multiplyScalar( 1 - distance / currentDist );
      var correctionHalf = correction.multiplyScalar( 0.5 );
      p1.position.add( correctionHalf );
      p2.position.sub( correctionHalf );
    }
    function Cloth( w, h ) {
      w = w || 10;
      h = h || 10;
      this.w = w;
      this.h = h;
      var particles = [];
      var constraints = [];
      var u, v;
      // Create particles
      for ( v = 0; v <= h; v ++ ) {
        for ( u = 0; u <= w; u ++ ) {
          particles.push(
            new Particle( u / w, v / h, 0, MASS )
          );
        }
      }
      
      // Structural
      for ( v = 0; v < h; v ++ ) {

        for ( u = 0; u < w; u ++ ) {
          constraints.push( [
            particles[ index( u, v ) ],
            particles[ index( u, v + 1 ) ],
            restDistance
          ]);
          
          constraints.push( [
            particles[ index( u, v ) ],
            particles[ index( u + 1, v ) ],
            restDistance
          ]);
        }

      }

      for ( u = w, v = 0; v < h; v ++ ) {
        constraints.push( [
          particles[ index( u, v ) ],
          particles[ index( u, v + 1 ) ],
          restDistance
        ]);
      }

      for ( v = h, u = 0; u < w; u ++ ) {
        constraints.push([
          particles[ index( u, v ) ],
          particles[ index( u + 1, v ) ],
          restDistance
        ]);
      }

      this.particles = particles;
      this.constraints = constraints;
      function index( u, v ) {
        return u + v * ( w + 1 );
      }
      this.index = index;
    }

    function simulate( time ) {
      if ( ! lastTime ) {
        lastTime = time;
        return;
      }
      var i, j, il, particles, particle, constraints, constraint;
      // Aerodynamics forces
      if ( params.enableWind ) {
        var indx;
        var normal = new THREE.Vector3();
        var indices = clothGeometry.index;
        var normals = clothGeometry.attributes.normal;
        particles = cloth.particles;
        for ( i = 0, il = indices.count; i < il; i += 3 ) {
          for ( j = 0; j < 3; j ++ ) {
            indx = indices.getX( i + j );
            normal.fromBufferAttribute( normals, indx );
            tmpForce.copy( normal ).normalize().multiplyScalar( normal.dot(windForce));
            particles[indx].addForce(tmpForce);
          }
        }
      }
      for ( particles = cloth.particles, i = 0, il = particles.length; i < il; i ++ ) {
        particle = particles[ i ];
        particle.addForce( gravity );
        particle.integrate( TIMESTEP_SQ );
      }

      // Start Constraints
      constraints = cloth.constraints;
      il = constraints.length;
      for ( i = 0; i < il; i ++ ) {
        constraint = constraints[ i ];
        satisfyConstraints( constraint[ 0 ], constraint[ 1 ], constraint[ 2 ] );
      }

      // Floor Constraints: literally tells the cloth where the floor is
      for ( particles = cloth.particles, i = 0, il = particles.length; i < il; i ++ ) {
        particle = particles[ i ];
        var pos = particle.position;
        if ( pos.y < - 550 ) {
          pos.y = - 550;
        }
      }

      // Pin Constraints
      for ( i = 0, il = pins.length; i < il; i ++ ) {
        var xy = pins[ i ];
        var p = particles[ xy ];
        p.position.copy( p.original );
        p.previous.copy( p.original );
      }
    }
    
    //testing cloth simulation
    var pinsFormation = [];
    // pins = [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16 ];
    pins = [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10 ];
    //pins = [ 0, 10 ];
    pinsFormation.push( pins );
    
   
    //var container, stats; // re-enable for debug
    var camera, scene, renderer;
    var clothGeometry;
    var object;
    //var composer;
    
    init();
    animate();

    function init() {
      
      // scene
      scene = new THREE.Scene();
      scene.background = new THREE.Color( 0xEBEBE8 );

      var viewSize = 20;
      var aspectRatio = window.innerWidth / window.innerHeight;
      var originalAspect = window.innerWidth / window.innerHeight;

      // wall

				/*var poleGeo1 = new THREE.PlaneBufferGeometry( 1000, 1000, 100);
				var poleMat1 = new THREE.MeshLambertMaterial();

				var mesh = new THREE.Mesh( poleGeo1, poleMat1 );
				mesh.position.x = 0;
				mesh.position.y = 0;
				mesh.position.z = - 200;

				mesh.receiveShadow = true;
				mesh.castShadow = true;

        scene.add( mesh );
        
        var poleGeo2 = new THREE.PlaneBufferGeometry( 100, 100, 100);
				var poleMat2 = new THREE.MeshLambertMaterial();

				var mesh2 = new THREE.Mesh( poleGeo2, poleMat2 );
				mesh2.position.x = 0;
				mesh2.position.y = 0;
				mesh2.position.z = - 100;

				mesh2.receiveShadow = true;
				mesh2.castShadow = true;

				scene.add( mesh2 );*/
      
      // camera - change this to set cam pov
      camera = new THREE.PerspectiveCamera( 35, window.innerWidth / window.innerHeight, 1, 10000 );
      camera.position.set( 0, 0, 850 );
      
      // lights
      var ambient = new THREE.AmbientLight( 0xffffff, 0.5 );
      scene.add( ambient );
      var dirLight = new THREE.DirectionalLight( 0xffffff, 0.5 );
      dirLight.position.set( 0, 0, 800 );
      dirLight.castShadow = true;
      scene.add( dirLight );

      
      // cloth material
      var loader = new THREE.TextureLoader();

      var clothTexture = loader.load(textileImage);
      clothTexture.magFilter = THREE.NearestFilter;
      clothTexture.minFilter = THREE.NearestFilter;
      clothTexture.transparent = true;
      clothTexture.anisotropy = 0;
      
      var clothMaterial = new THREE.MeshPhongMaterial({
        map: clothTexture,
        side: THREE.DoubleSide,
        alphaTest: 0.5
      });
      
      // cloth geometry
      clothGeometry = new THREE.ParametricBufferGeometry( clothFunction, cloth.w, cloth.h );
      
      // cloth mesh
      object = new THREE.Mesh( clothGeometry, clothMaterial );
      object.position.set( 0, 0, 0 );
      object.castShadow = false;
      scene.add(object);
      object.customDepthMaterial = new THREE.MeshDepthMaterial({
        depthPacking: THREE.RGBADepthPacking,
        map: clothTexture,
        alphaTest: 0.5
      });
      
      // renderer
      renderer = new THREE.WebGLRenderer({antialias: false});
      
      renderer.setPixelRatio( window.devicePixelRatio );

      renderer.setSize( mountRef.current.clientWidth, window.innerHeight );

      renderer.gammaInput = true;
      renderer.gammaOutput = true;
      renderer.shadowMap.enabled = true;
      renderer.shadowMap.type = THREE.PCFSoftShadowMap;
      
      // controls - enable controls for zoom, and pan
      /*var controls = new OrbitControls( camera, renderer.domElement );
      controls.maxPolarAngle = Math.PI * 0.5;
      controls.minDistance = 1000;
      controls.maxDistance = 5000;*/

      // DOM

      window.addEventListener( 'resize', onWindowResize, false );

      mountRef.current.appendChild( renderer.domElement );
    }

    function onWindowResize() {
      
      /*camera.aspect = window.innerWidth / window.innerHeight;

      camera.updateProjectionMatrix();

      console.log(window.innerWidth);
      
      renderer.setSize( mountRef.current.clientWidth, window.innerHeight );*/

      var aspect = window.innerWidth / window.innerHeight;
      var change = originalAspect / aspect;
      var newSize = viewSize * change;
      camera.left = -aspect * newSize / 2;
      camera.right = aspect * newSize  / 2;
      camera.top = newSize / 2;
      camera.bottom = -newSize / 2;
      camera.updateProjectionMatrix();

      renderer.setSize(window.innerWidth, window.innerHeight);

      console.log(window.innerWidth);
    }

    function animate() {
      requestAnimationFrame( animate );
      var time = Date.now();
      var windStrength = Math.cos( time / 7000 ) * 10 + 20;
      windForce.set( Math.sin(time / 500), Math.cos(time / 600), Math.sin(time / 200));
      windForce.normalize();
      windForce.multiplyScalar(windStrength);
      simulate( time );
      render();
      //stats.update(); //if we need to debug, you'll need to re-enable stats
    }

    function render() {
      var p = cloth.particles;
      for ( var i = 0, il = p.length; i < il; i ++ ) {
        var v = p[ i ].position;
        clothGeometry.attributes.position.setXYZ( i, v.x, v.y, v.z );
      }
      clothGeometry.attributes.position.needsUpdate = true;
      clothGeometry.computeVertexNormals();
      renderer.render( scene, camera );
    } 
// END THREEJS
 }
 